export default __webpack_public_path__ + "static/media/mark-unread.9e2253ec.svg";